
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-deepseek-demo-deep-seek-chat-provider","docs-x-sdk-chat-provider-deepseek-demo-deepseek"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.en-US.md?type=demo')
};